/** Helpers for letter body HTML vs plain text. */

export function isLetterHtml(body) {
  return /<(p|div|br|b|i|u|strong|em|ul|ol|li|h[1-6]|span|table|tr|td|th|hr|blockquote|s|strike|sub|sup)\b/i.test(
    body || ""
  );
}
/** Convert plain factory templates into simple HTML paragraphs. */
export function plainToLetterHtml(text) {
  if (!text) return "<p><br></p>";
  if (isLetterHtml(text)) return text;
  return String(text)
    .split(/\n\n+/)
    .map((block) => {
      const inner = block
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n/g, "<br>");
      return `<p>${inner || "<br>"}</p>`;
    })
    .join("");
}

export function letterHtmlIsEmpty(html) {
  if (!html) return true;
  const text = String(html)
    .replace(/<br\s*\/?>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]+>/g, "")
    .trim();
  return !text;
}
